// extracted by mini-css-extract-plugin
module.exports = {"altHero":"si","altProd":"ti","subheading":"ui","subtext":"vi","extrainfo":"wi","copy":"xi","cta":"yi","disabled":"zi"};